export default __webpack_public_path__ + "static/media/Future Learn Learn to code for web.17340510.webp";